module.exports = __webpack_public_path__ + "img/conferm.d86157a4.svg";